import format from "date-fns/format";
import { convertDbDateToCenterTZ } from "../../../common/dateHelpers";
import { AuditLog } from "./types";

const dateFormatType = "MM/dd/yyyy hh:mm a";

const getAuditLogChangedAt = (auditLog: AuditLog, timezone?: string) => {
  let changedAt = format(new Date(auditLog.created_at), dateFormatType);
  const isAppointmentAuditLog = "appointment_id" in auditLog;

  if (isAppointmentAuditLog) {
    const { dateTimezone } = convertDbDateToCenterTZ({
      dateString: auditLog.created_at,
      timezone: auditLog.appointment.center.timezone,
    });
    changedAt = format(dateTimezone, dateFormatType);
  }

  if (!isAppointmentAuditLog && timezone) {
    const { dateTimezone } = convertDbDateToCenterTZ({
      dateString: auditLog.created_at,
      timezone,
    });
    changedAt = format(dateTimezone, dateFormatType);
  }

  return changedAt;
};

export default getAuditLogChangedAt;
